/* Cart gift-wrap flow — two-screen drawer:
   1) pick which cart products to wrap, 2) pick one wrap design (a variant of the wrap
   product). One wrap line is added per selected product; total = variant price x count.
   Rendered once from the layout; opened by the cart strip. */
(function () {
  var OPEN_CLASS = 'overflow-hidden-html';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var currentScreen = 'products';
  var selectedProducts = {}; // key -> { title }
  var selectedVariant = null; // { id, price }
  var freshBase = 0; // cart total (paise) captured on open
  var busy = false;
  var savedScrollY = 0;

  function modal() {
    return document.querySelector('[data-gw-modal]');
  }
  function money(paise) {
    return '₹' + (Math.round(paise) / 100).toLocaleString('en-IN');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function sizedImg(url, w) {
    if (!url) return '';
    return url.indexOf('?') >= 0 ? url + '&width=' + w : url + '?width=' + w;
  }
  function selectedCount() {
    return Object.keys(selectedProducts).length;
  }

  /* Identity tokens a gift wrap can be anchored to. A wrap line (from this cart flow
     or from a product's PDP) carries `_gift_wrap:'1'` + `_wrap_for:<token>`. The cart
     flow anchors by line key (known at add time); a PDP wrap is added together with its
     product so the line key isn't known yet — it anchors by variant id or product id.
     Matching `_wrap_for` against any of these tokens covers both origins, so a product
     wrapped on its PDP is detected here exactly like one wrapped from the cart. */
  function lineTokens(it) {
    var t = [];
    if (it.key != null) t.push(String(it.key));
    if (it.variant_id != null) t.push(String(it.variant_id));
    if (it.id != null) t.push(String(it.id));
    if (it.product_id != null) t.push(String(it.product_id));
    return t;
  }
  function tokenInSet(it, set) {
    var toks = lineTokens(it);
    for (var i = 0; i < toks.length; i++) {
      if (set[toks[i]]) return true;
    }
    return false;
  }

  /* ── Scroll lock ──
     The real scroller here is the <html> element (document.scrollingElement ===
     documentElement), so overflow:hidden on <body> alone does NOT stop the background
     from scrolling — the lock has to go on <html>. overflow:hidden freezes it at the
     current position (no jump); no position:fixed / top offset, which is what fought the
     cart drawer's lock and shunted the page to a blank area. */
  function lockScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'relative';
  }
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
  }

  function closeCartDrawer() {
    // Hide the drawer by dropping `.active` — do NOT call the theme's close(): close()
    // clears body.style.position/overflow, which repaints the whole page (a visible flash)
    // and drops the scroll lock mid-open. lockScroll owns the scroll lock throughout.
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active')) {
      d.classList.remove('active');
      d.setAttribute('aria-hidden', 'true');
    }
  }
  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') {
      try { d.open(); } catch (e) { /* noop */ }
    }
  }

  /* ── Section re-render (keep the cart in sync after adding wraps) ── */
  function sectionTargets() {
    var list = [{ section: 'cart-drawer', host: '#CartDrawer', pick: '#CartDrawer' }];
    if (document.getElementById('cart-icon-bubble')) {
      list.push({ section: 'cart-icon-bubble', host: '#cart-icon-bubble', pick: '.shopify-section' });
    }
    return list;
  }
  function renderSections(targets, rendered) {
    if (!rendered) return;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      var html = rendered[t.section];
      var host = document.querySelector(t.host);
      if (!html || !host) continue;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(t.pick);
      if (fresh) host.innerHTML = fresh.innerHTML;
    }
  }
  function notifyCartUpdated(cartData) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cartData: cartData });
      }
    } catch (e) { /* pub/sub optional */ }
  }

  /* ── Build the eligible-products list (screen 1) from the live cart ── */
  function buildProducts(cart) {
    var el = modal();
    var host = el.querySelector('[data-gw-products]');
    var emptyEl = el.querySelector('[data-gw-products-empty]');
    host.innerHTML = '';
    selectedProducts = {};

    var items = (cart && cart.items) || [];
    var excluded = (el.getAttribute('data-gw-excluded') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var wrapHandle = (el.getAttribute('data-gw-wrap-handle') || '').toLowerCase();

    // Targets that already carry a gift wrap — whether added from this cart flow (ref =
    // line key) or from the product's PDP (ref = variant/product id). Not re-wrappable.
    var wrappedTargets = {};
    // Products wrapped via the PDP "Personalise Your Gift" wizard: its ribbon add-on line
    // (_gift_role:'ribbon') shares the parent product's _gift_group token. A parent in
    // such a group is already wrapped, so the cart flow must not offer a second wrap —
    // this is the Option-A guarantee (both flows ship, never a double wrap/charge).
    var pdpWrappedGroups = {};
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._gift_wrap === '1' && p._wrap_for) wrappedTargets[String(p._wrap_for)] = true;
      if (p._gift_role === 'ribbon' && p._gift_group) pdpWrappedGroups[String(p._gift_group)] = true;
    });

    var count = 0;
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._gift_wrap === '1') return;                 // a cart-flow wrap line itself
      if (p._gift_role && p._gift_role !== 'parent') return; // a PDP wizard add-on line (engraving/postcard/sleeve/ribbon)
      if (p._gift_group && pdpWrappedGroups[String(p._gift_group)]) return; // already wrapped via the PDP wizard
      if (tokenInSet(it, wrappedTargets)) return;       // already wrapped (cart or PDP ref)
      if (it.gift_card) return;                         // gift cards
      // Free/promo gifts (bxgy / spend-tier / gift-rule / auto_gift markers) ARE wrappable
      // by product decision — a shopper can gift-wrap a free item. Do not exclude them here.
      if (excluded.indexOf((it.product_type || '').toLowerCase()) >= 0) return; // engraving / post card / gifting / gift-box / sleeves
      if ((it.handle || '').toLowerCase() === wrapHandle) return; // the wrap product itself

      count++;
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'gw-product';
      row.setAttribute('data-gw-product', '');
      row.setAttribute('data-key', it.key);
      row.setAttribute('data-handle', it.handle || '');
      row.setAttribute('aria-checked', 'false');
      row.setAttribute('data-title', it.product_title || '');
      row.innerHTML =
        '<img class="gw-product__img" src="' + esc(sizedImg(img, 96)) + '" alt="" width="48" height="48">' +
        '<span class="gw-product__info">' +
          '<span class="gw-product__title">' + esc(it.product_title) + '</span>' +
          (it.variant_title ? '<span class="gw-product__variant">' + esc(it.variant_title) + '</span>' : '') +
        '</span>' +
        '<span class="gw-product__check" aria-hidden="true"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg></span>';
      host.appendChild(row);
    });
    if (emptyEl) emptyEl.hidden = count > 0;
  }

  /* ── Open / close ── */
  function openModal() {
    var el = modal();
    if (!el) return;
    currentScreen = 'products';
    selectedVariant = null;
    Array.prototype.forEach.call(el.querySelectorAll('[data-gw-design]'), function (d) { d.setAttribute('aria-checked', 'false'); });
    showScreen('products');
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    lockScroll();
    closeCartDrawer();
    // Build the product list + subtotal from the live cart.
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        freshBase = cart.total_price || 0;
        var countEl = el.querySelector('[data-gw-count]');
        // Match the theme cart drawer's exact format: "(N Item)".
        if (countEl) countEl.textContent = '(' + cart.item_count + ' Item)';
        buildProducts(cart);
        updateSubtotal();
        updateCta();
      });
  }
  function closeModal() {
    var el = modal();
    if (!el) return;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  /* ── Screen navigation ── */
  function showScreen(name) {
    var el = modal();
    currentScreen = name;
    Array.prototype.forEach.call(el.querySelectorAll('[data-gw-screen]'), function (s) {
      s.hidden = s.getAttribute('data-gw-screen') !== name;
    });
    var cta = el.querySelector('[data-gw-cta]');
    if (cta) cta.textContent = name === 'design' ? el.getAttribute('data-gw-add-cta') : el.getAttribute('data-gw-select-cta');
    updateSubtotal();
    updateCta();
  }

  function updateSubtotal() {
    var el = modal();
    var sub = el.querySelector('[data-gw-subtotal]');
    if (!sub) return;
    var extra = currentScreen === 'design' && selectedVariant ? selectedVariant.price * selectedCount() : 0;
    sub.textContent = money(freshBase + extra);
  }

  function updateCta() {
    var el = modal();
    var cta = el.querySelector('[data-gw-cta]');
    if (!cta) return;
    cta.disabled = currentScreen === 'products' ? selectedCount() === 0 : !selectedVariant;
  }

  /* ── Selection ── */
  function toggleProduct(row) {
    var key = row.getAttribute('data-key');
    var on = row.getAttribute('aria-checked') === 'true';
    if (on) {
      row.setAttribute('aria-checked', 'false');
      delete selectedProducts[key];
    } else {
      row.setAttribute('aria-checked', 'true');
      selectedProducts[key] = { title: row.getAttribute('data-title') || '', handle: row.getAttribute('data-handle') || '' };
    }
    updateSubtotal();
    updateCta();
  }
  function selectDesign(btn) {
    var el = modal();
    Array.prototype.forEach.call(el.querySelectorAll('[data-gw-design]'), function (d) { d.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    selectedVariant = { id: btn.getAttribute('data-variant-id'), price: Number(btn.getAttribute('data-price')) || 0, sku: btn.getAttribute('data-sku') || '' };
    updateSubtotal();
    updateCta();
  }

  /* ── Add wraps (one line per selected product) ── */
  function addWrap() {
    if (busy || !selectedVariant || selectedCount() === 0) return;
    busy = true;
    var cta = modal().querySelector('[data-gw-cta]');
    if (cta) cta.disabled = true;
    var targets = sectionTargets();
    var keys = Object.keys(selectedProducts);
    var sku = selectedVariant.sku || '';

    // One wrap line per product: `_wrap_for` points at the product's (possibly re-keyed)
    // line, and `_parent_handle` carries the product's handle for fulfilment.
    function addWrapLines(keyMap) {
      var items = keys.map(function (oldKey) {
        return {
          id: Number(selectedVariant.id),
          quantity: 1,
          properties: {
            _gift_wrap: '1',
            _wrap_for: keyMap[oldKey] || oldKey,
            'Wrapped Item': selectedProducts[oldKey].title,
            _parent_handle: selectedProducts[oldKey].handle || '',
          },
        };
      });
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: targets.map(function (t) { return t.section; }).join(','), sections_url: window.location.pathname }),
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error('add failed'); return d; }); });
    }

    // Stamp the chosen wrap's SKU onto each wrapped product line (the reverse link of
    // `_parent_handle`). Updating a line's properties re-keys it in Shopify's cart, so
    // we map each old key to its new key for the wrap lines' `_wrap_for`. No SKU → skip
    // straight to adding the wraps against the existing keys.
    function stampSkuAndMap() {
      if (!sku) return Promise.resolve({});
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var byKey = {};
          (cart.items || []).forEach(function (it) { byKey[it.key] = it; });
          var keyMap = {};
          var chain = Promise.resolve();
          keys.forEach(function (oldKey) {
            chain = chain.then(function () {
              var line = byKey[oldKey];
              if (!line) { keyMap[oldKey] = oldKey; return; }
              var props = Object.assign({}, line.properties || {});
              props._gift_wrap_sku = sku;
              return fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: oldKey, quantity: line.quantity, properties: props }),
              })
                .then(function (r) { return r.json(); })
                .then(function (updated) {
                  var claimed = keys.map(function (k) { return keyMap[k]; });
                  var match = (updated.items || []).filter(function (it) {
                    return it.properties && it.properties._gift_wrap !== '1' &&
                      it.properties._gift_wrap_sku === sku &&
                      String(it.variant_id) === String(line.variant_id) &&
                      claimed.indexOf(it.key) < 0;
                  })[0];
                  keyMap[oldKey] = match ? match.key : oldKey;
                });
            });
          });
          return chain.then(function () { return keyMap; });
        });
    }

    stampSkuAndMap()
      .then(addWrapLines)
      .then(function (data) {
        closeModal();
        renderSections(targets, data.sections);
        notifyCartUpdated(data);
        openCartDrawer();
      })
      .catch(function () { if (cta) cta.disabled = false; })
      .finally(function () { busy = false; });
  }

  /* ── Delegated events ── */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-gw-open]')) { event.preventDefault(); openModal(); return; }
    if (t.closest('[data-gw-close]')) { event.preventDefault(); closeModal(); return; }
    if (t.closest('[data-gw-back]')) { event.preventDefault(); showScreen('products'); return; }

    var prod = t.closest('[data-gw-product]');
    if (prod) { event.preventDefault(); toggleProduct(prod); return; }

    var design = t.closest('[data-gw-design]');
    if (design) { event.preventDefault(); selectDesign(design); return; }

    if (t.closest('[data-gw-cta]')) {
      event.preventDefault();
      if (currentScreen === 'products') {
        if (selectedCount() > 0) showScreen('design');
      } else {
        addWrap();
      }
      return;
    }

    var wrapRemove = t.closest('[data-gw-wrap-remove]');
    if (wrapRemove) { event.preventDefault(); removeWrapLine(wrapRemove.getAttribute('data-line-key'), wrapRemove); return; }

    // Remove a PDP-wizard personalisation (cart-gift-group's "Personalisation Added"
    // rows). Its remove is an <a href="/cart/change…"> meant to be ajax-upgraded; without
    // this it navigates to the cart page. This script loads globally, so it's the upgrade.
    var giftRemove = t.closest('.js-remove-gift');
    if (giftRemove) { event.preventDefault(); removeGiftLine(giftRemove.getAttribute('data-gift-line-key'), giftRemove); return; }
  });

  /* ── Remove a single wrap line from the cart ── */
  function removeWrapLine(lineKey, button) {
    if (!lineKey || busy) return;
    busy = true;
    // Swap the trash icon for a spinner while the removal is in flight.
    var icon = button && button.querySelector('.cart-wrap-line__remove-icon');
    var loader = button && button.querySelector('[data-gw-wrap-remove-loader]');
    if (icon) icon.style.display = 'none';
    if (loader) loader.hidden = false;
    if (button) button.disabled = true;
    var targets = sectionTargets();
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: targets.map(function (t) { return t.section; }).join(','), sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderSections(targets, data.sections); notifyCartUpdated(data); })
      .catch(function () {
        if (icon) icon.style.display = '';
        if (loader) loader.hidden = true;
        if (button) button.disabled = false;
      })
      .finally(function () { busy = false; });
  }

  /* ── Remove a single PDP-wizard personalisation line (ajax, stays in the drawer) ── */
  function removeGiftLine(lineKey, el) {
    if (!lineKey || busy) return;
    busy = true;
    // cart-gift-group ships a hidden spinner beside the bin; dropping `.hidden` shows the
    // spinner and hides the bin via CSS (.loading__spinner:not(.hidden) ~ svg).
    var spinner = el.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    el.setAttribute('aria-disabled', 'true');
    var targets = sectionTargets();
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: targets.map(function (t) { return t.section; }).join(','), sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderSections(targets, data.sections); notifyCartUpdated(data); })
      .catch(function () {
        if (spinner) spinner.classList.add('hidden');
        el.removeAttribute('aria-disabled');
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var el = modal();
    if (!el || el.hidden) return;
    event.stopPropagation();
    closeModal();
  }, true);

  /* ── Drop orphaned gift lines ──
     Two kinds of add-on line can be left stranded (invisible but still charged) when the
     product they belong to is removed from the cart:
       (1) cart-flow wrap lines (`_gift_wrap:'1'`), anchored to their product via
           `_wrap_for` — a line key or a variant/product id (see lineTokens);
       (2) PDP-wizard add-ons (`_gift_group` + `_gift_role` != 'parent' — engraving, post
           card, sleeve, ribbon), anchored to their parent product line, which carries the
           same `_gift_group` with `_gift_role:'parent'`.
     On every cart change, remove (1) when no live non-wrap line matches its `_wrap_for`,
     and (2) when its group's parent line is gone. Without (2), deleting a personalised
     product via the normal cart controls leaves its gift wrap / engraving still charged. */
  var pruningWraps = false;
  function pruneOrphanWraps() {
    if (pruningWraps || busy) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var liveTokens = {};
        var liveGiftGroups = {}; // _gift_group tokens that still have a parent line present
        items.forEach(function (it) {
          var p = it.properties || {};
          if (p._gift_group && p._gift_role === 'parent') liveGiftGroups[String(p._gift_group)] = true;
          if (p._gift_wrap === '1') return;
          lineTokens(it).forEach(function (tok) { liveTokens[tok] = true; });
        });
        var orphans = [];
        items.forEach(function (it) {
          var p = it.properties || {};
          if (p._gift_wrap === '1' && (!p._wrap_for || !liveTokens[String(p._wrap_for)])) { orphans.push(it.key); return; }
          if (p._gift_group && p._gift_role && p._gift_role !== 'parent' && !liveGiftGroups[String(p._gift_group)]) orphans.push(it.key);
        });
        if (!orphans.length) return;
        pruningWraps = true;
        var updates = {};
        orphans.forEach(function (k) { updates[k] = 0; });
        var targets = sectionTargets();
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: targets.map(function (t) { return t.section; }).join(','), sections_url: window.location.pathname }),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) { renderSections(targets, data.sections); notifyCartUpdated(data); })
          .finally(function () { pruningWraps = false; });
      })
      .catch(function () { pruningWraps = false; });
  }

  function initWrapGuard() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { pruneOrphanWraps(); });
    }
    pruneOrphanWraps();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWrapGuard);
  } else {
    initWrapGuard();
  }
})();
